module.exports = __webpack_public_path__ + "glyphicons-filetypes-regular.5d59aacd0d720b26cc93.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.filetypes.pro/glyphicons-filetypes-regular.ttf
// module id = ../../../../../src/assets/css/fonts/glyphicons.filetypes.pro/glyphicons-filetypes-regular.ttf
// module chunks = 2